(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/dialogs/success-payment.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/dialogs/success-payment.js');
"use strict";


const getTitle = _ref => {
  let deliveryDate = _ref.deliveryDate,
    products = _ref.products,
    recipientName = _ref.recipientName;
  const isPlural = products.length > 1 || products.some(product => product.count > 1);
  if (deliveryDate) {
    return "".concat(isPlural ? 'Dina lotter är betalade!' : "Din ".concat(products[0].name, " \xE4r betalad!"));
  }
  return "".concat(isPlural ? 'Dina lotter är betalade och skickade' : "Din ".concat(products[0].name, " \xE4r betalad och skickad"), " till ").concat(recipientName, "!");
};
const getMessage = _ref2 => {
  let deliveryDate = _ref2.deliveryDate,
    products = _ref2.products,
    recipientName = _ref2.recipientName;
  const isPlural = products.length > 1 || products[0].count > 1;
  const dateObj = deliveryDate ? new Date(deliveryDate) : new Date();
  const readableDate = dateObj.toLocaleDateString('sv-SE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  const readableTime = dateFns.format(dateObj, 'HH:mm');
  const upperText = deliveryDate ? "".concat(isPlural ? 'Lotterna' : 'Lotten', " kommer skickas till ").concat(recipientName, "\n      <span class=\"f-bold nowrap\">").concat(readableDate, ", kl ").concat(readableTime, "</span><br><br>") : '';
  const lowerText = "".concat(isPlural ? 'Dina köpta presentlotter' : 'Din köpta presentlott', " som du gett bort hittar du i\n  <a class=\"alert-text-link\" href=\"").concat(svs.core.urlMapping.get('myBetsTicketGifts'), "\">Mina spel</a>.");
  const text = upperText + lowerText;
  return [{
    type: svs.components.dialog.message.TEXT,
    text,
    align: svs.components.dialog.message.align.CENTER
  }];
};
const successPayment = _ref3 => {
  let products = _ref3.products,
    recipientName = _ref3.recipientName,
    deliveryDate = _ref3.deliveryDate,
    next = _ref3.next;
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'games',
    title: getTitle({
      deliveryDate,
      products,
      recipientName
    }),
    message: [...getMessage({
      deliveryDate,
      products,
      recipientName
    })],
    actions: [{
      title: 'Okej',
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
setGlobal('svs.tickets_giftshop.dialogs.successPayment', successPayment);

 })(window);